/**
 * This should contain list of all feature flags and corresponding selector util functions if any
 * For adding a new feature flag please define a new constant here and then add selector util
 * function if needed.
 */
import { makeIsFeatureFlagOn } from 'modules/meta/launchdarkly/selectors';

export const CartStopServerUpgradeFF = 'cart-stop-server-upgrade';
export const DisabledRussianPurchases = 'cart-disable-russian-purchases';
export const AddAtlasToPurchaseFF = 'cart-add-atlas-purchase';
export const RuByRestrictionFF = 'cart-ruby-sanctions';
export const DirectBuySupportFF = 'cart-direct-buy-support';
export const CartDirectBuyCCPQuoteLinkFF = 'cart-direct-buy-ccp-quote-link';
export const DisableServerAddonsFF = 'disable-server-addons';
export const JPDInCatalogFF = 'cart-add-jpd-to-purchase';
export const TaaSValidationTaxIdFF = 'cart-taas-validation-for-tax-id';
export const DisableBambooCrowdServerAddonsFF = 'cart-disable-bamboo-crowd-addons';
export const AcademicPricingToggleFF = 'cart-remove-academic-pricing-toggle';

export const isCartStopServerUpgradeFFOn = makeIsFeatureFlagOn(CartStopServerUpgradeFF);
export const isRussianPurchaseDisabledFFOn = makeIsFeatureFlagOn(DisabledRussianPurchases);
export const isAddAtlasToPurchaseFFOn = makeIsFeatureFlagOn(AddAtlasToPurchaseFF);
export const isRuByRestrictionFFOn = makeIsFeatureFlagOn(RuByRestrictionFF);
export const isDirectBuySupportFFOn = makeIsFeatureFlagOn(DirectBuySupportFF);
export const isCartDirectBuyCCPQuoteLinkFFOn = makeIsFeatureFlagOn(CartDirectBuyCCPQuoteLinkFF);
export const isDisableServerDeploymentAddonsFFOn = makeIsFeatureFlagOn(DisableServerAddonsFF);
export const isJPDInCatalogFFOn = makeIsFeatureFlagOn(JPDInCatalogFF);
export const isTaaSValidationTaxIdFFOn = makeIsFeatureFlagOn(TaaSValidationTaxIdFF);
export const isDisableBambooCrowdServerOptionAddonsFFOn = makeIsFeatureFlagOn(
  DisableBambooCrowdServerAddonsFF,
);
export const isAcademicPricingToggleFFOn = makeIsFeatureFlagOn(AcademicPricingToggleFF);
